var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 197,
    viewBox: "0 0 250 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "img-upload-a",
    points: "0 0 140 0 140 140 0 140"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.894 .09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9F1FF",
    fillRule: "nonzero",
    d: "M220.036231,175.332364 C240.638231,156.439364 257.145231,132.517364 243.985231,106.157364 C230.825231,79.7973639 205.293231,81.7223639 189.657231,57.6063639 C170.112231,27.4617639 181.141231,2.49076394 132.279231,0.141863937 C83.4162311,-2.20713606 56.5487311,24.9238639 30.3583311,58.5918639 C4.16803114,92.2593639 -9.31806886,121.034364 7.29523114,163.119364 C23.9085311,205.204364 60.1149311,195.661364 75.2072311,191.188364 C113.515231,179.835364 128.077231,165.461364 146.735231,184.148364 C164.828231,202.268364 192.482231,200.601364 220.036231,175.332364 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.106 .91)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "img-upload-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img-upload-a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0375FF",
    strokeLinejoin: "round",
    strokeWidth: 5,
    mask: "url(#img-upload-b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.338 2.05)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M88.058 120.8533L101.23 120.8533C103.491 120.8533 105.324 119.0203 105.324 116.7583L105.324 31.7174 83.176 9.5698 13.716 9.5698C11.454 9.5698 9.621 11.4032 9.621 13.6642L9.621 24.7584M9.621 34.3053L9.621 116.7583C9.621 119.0193 11.454 120.8533 13.716 120.8533L27.047 120.8533"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M9.621,111.2833 L4.094,111.2833 C1.833,111.2833 0,109.4503 0,107.1893 L0,4.0944 C0,1.8334 1.833,-7.10542736e-15 4.094,-7.10542736e-15 L90.078,-7.10542736e-15 C92.382,-7.10542736e-15 94.25,1.8681 94.25,4.1721 L94.25,20.6437"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "83.176 9.57 83.176 31.713 105.324 31.717"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.993,
    x2: 82.054,
    y1: 47.976,
    y2: 47.976,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.993,
    x2: 82.054,
    y1: 60.071,
    y2: 60.071,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.361,
    x2: 82.054,
    y1: 72.407,
    y2: 72.407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.993,
    x2: 62.71,
    y1: 72.407,
    y2: 72.407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.523,
    x2: 57.523,
    y1: 124.581,
    y2: 100.078,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinecap: "round",
    points: "48.555 108.772 57.523 99.804 66.491 108.772"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M81.23,112.1933 C81.23,99.1003 70.616,88.4873 57.523,88.4873 C44.43,88.4873 33.817,99.1003 33.817,112.1933 C33.817,125.2853 44.43,135.8983 57.523,135.8983 C70.616,135.8983 81.23,125.2853 81.23,112.1933 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUpload);
export default __webpack_public_path__ + "static/media/img-upload.1a908578ed9a8708c6f415894d9fd865.svg";
export { ForwardRef as ReactComponent };